import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-program-achievement-test-listening',
  templateUrl: './program-achievement-test-listening.component.html',
  styleUrls: ['./program-achievement-test-listening.component.scss']
})
export class ProgramAchievementTestListeningComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
